// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__zkuaE","detailsBorder":"styles_detailsBorder__1AXPJ"};